export const YellowMinusLogo = () => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5 23.25C17.7132 23.25 22.75 18.2132 22.75 12C22.75 5.7868 17.7132 0.75 11.5 0.75C5.2868 0.75 0.25 5.7868 0.25 12C0.25 18.2132 5.2868 23.25 11.5 23.25Z"
        fill="#FFB32C"
      />
      <path
        d="M16.5218 13.6227H6.4793C5.58305 13.6227 4.85742 12.897 4.85742 12.0008C4.85742 11.1045 5.58305 10.3789 6.4793 10.3789H16.5199C17.4162 10.3789 18.1418 11.1045 18.1418 12.0008C18.1418 12.897 17.4162 13.6227 16.5218 13.6227Z"
        fill="#FFFCEE"
      />
    </svg>
  );
};
